<template>
  <div class="container">
    <div class="input-item" v-for="(item,index) in checkin.reg_info" :key="item.field_key">
      <!-- 单行文本 -->
      <div v-if="item.status==1&&item.field_type==0">
        <div>{{item.field_name}}<span v-if="item.require==1">（<span style="color: #fe523c;">*</span>必填）</span></div>
        <div style="display:flex;">
          <input class="input" style="flex:1;"  @input="inputchange($event,index)" :maxlength="item.field_key==1?20:500" type="text" :placeholder="item.field_desc?item.field_desc:'点击输入'" />
        </div>
      </div>
      <!-- 多行文本 -->
      <div v-if="item.status==1&&item.field_type==7">
        <div>{{item.field_name}}<span v-if="item.require==1">（<span style="color: #fe523c;">*</span>必填）</span></div>
        <textarea @input="inputchange($event,index)" class="textarea" :placeholder="item.field_desc?item.field_desc:'点击输入'"></textarea>
      </div>
      <!-- 单选 -->
      <div v-if="item.status==1&&item.field_type==1"  @click="showPickerView(item.options, item.field_value, index)">
        <div>{{item.field_name}}<span v-if="item.require==1">（<span style="color: #fe523c;">*</span>必填）</span></div>
        <div class="input" style="display:flex;flex-direction:row;align-items:center;">
          <span 
              style="margin-right:10px;flex: 1;"
              :style="{color:item.field_value ? '#333': '#999'}">{{
              item.field_value ? item.field_value : item.field_desc?item.field_desc:'点击输入'
            }}</span>
          <img class="right-arrow" src="@/assets/icon/right_arrow.png" />
        </div>
      </div>
      <!-- 手机号类型 -->
      <div v-if="item.status==1&&item.field_type==13">
        <div>{{item.field_name}}<span v-if="item.require==1">（<span style="color: #fe523c;">*</span>必填）</span></div>
        <!-- 不用验证手机号直接输入 -->
        <div style="display:flex;">
          <input  @input="inputchange($event,index)" style="flex:1" class="input" type="text" :placeholder="item.field_desc?item.field_desc:'点击输入'" />
        </div>
      </div>
    </div>

    <div>
      <div class="btn" @click="save">完成</div>
    </div>

    <!-- 单选单框 -->
    <van-popup v-model="showPicker"
               position="bottom">
      <van-picker :columns="pickerColumns"
                  show-toolbar
                  @confirm="onConfirm"
                  @cancel="onCancel"
                  :default-index="defaultIndex"></van-picker>
    </van-popup>
  </div>
  
</template>

<script>
import { hasSensitiveWords, replaceAll, getToken, configApi, isIos,isTextEmpty} from '@/utils/common.js'
import { Dialog, ImagePreview, Toast,Picker } from 'vant'
import http from '@/utils/http'
import api from '@/utils/api'
export default {
  name:'info',
  data() {
    return {
      checkin:{},
      showPicker:false,
      pickerColumns: [],
      defaultIndex: -1,
      cellIndex: -1,
    }
  },
  mounted() {
    this.checkin = JSON.parse(localStorage.getItem('checkin'))
  },
  methods:{
    save() {
      let reg_info = this.checkin.reg_info
      for (let i = 0; i < reg_info.length;i++) {
        if(reg_info[i].status == 1 && reg_info[i].require == 1 && isTextEmpty(reg_info[i].field_value)) {
          this.showDialog(`${reg_info[i].field_name}为必填项`)
          return
        }
        if(reg_info[i].status == 1 & hasSensitiveWords(reg_info[i].field_value)) {
          this.showDialog(`${reg_info[i].field_name}填写的内容包含敏感词【${hasSensitiveWords(reg_info[i].field_value)}】，请修改`)
          return
        }
      }
      let params = {
        access_token:getToken(),
        cid:this.checkin.cid,
        reg_params:this.checkin.reg_info,
        join_name:'',
        join_phone:'',
        referer:this.checkin.refer_uid,
        refer_type:29
      }
      http.post(api.checkin.joinCheckin, params).then((res) => {
        this.$router.go(-1)
      })
      // 
    },
    showPickerView(columns, defaultValue, index) {
      this.pickerColumns = columns
      if (defaultValue) {
        this.defaultIndex = columns.indexOf(defaultValue)
      }
      this.cellIndex = index
      this.showPicker = true
    },
    inputchange($e,index) {
      this.checkin.reg_info[index].field_value = $e.target.value
    },
    onCancel(e) {
      this.showPicker = false
    },
    onConfirm(value) {
      this.checkin.reg_info[this.cellIndex].field_value = value
      this.showPicker = false
    },
    // 展示弹窗
    showDialog(msg='') {
      Dialog({
        title:'温馨提示',
        message:msg,
        confirmButtonText: '我知道啦',
        confirmButtonColor: '#12b7f5',
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.container {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #ffffff;
  width: 100vw;
  height: 100vh;
  padding: rem(30);
  box-sizing: border-box;
  overflow-y: scroll;
}
.input-item {
  margin-bottom: rem(20);
}
.input {
  border-radius: rem(8);
  height: rem(80);
  border: 1px solid #eee;
  margin-top: rem(20);
  padding: 0rem rem(20);
}
.textarea {
  border-radius:rem(8);
  border:1px solid #eee;
  margin-top:rem(20);
  padding:rem(20);
  box-sizing: border-box;
  width: rem(690);
  height: rem(310);
}
.right-arrow {
  width: rem(36);
  height: rem(36);
  margin-left: rem(20);
}
.btn {
  width: rem(690);
  height: rem(90);
  background: #12b7f5;
  color: #fff;
  font-size: rem(36);
  margin-bottom:rem(20);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: rem(8);

}
</style>


// WEBPACK FOOTER //
// src/pages/info/info.vue